import { NgModule } from '@angular/core';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';

import { SharedModule } from '@shared';

import { RouteKeyNumberModule, RouteKeyNumbersModule, TaskFeasibilityInfoModule } from 'planner-shared';

import { RoutePlanningComponent } from './route-planning.component';
import { RoutePlanningInfoComponent } from './info/route-planning-info.component';
import { RoutePlanningEmployeesComponent } from './employees/route-planning-employees.component';
import { RoutePlanningTasksComponent } from './tasks/route-planning-tasks.component';
import { RoutePlanningExportComponent } from './export/route-planning-export.component';
import { EmployeeRouteInfoComponent } from './export/employee-route-info/employee-route-info.component';
import { RoutePlanningUnallocatedTasksComponent } from './tasks/unallocated/route-planning-unallocated-tasks.component';
import { TravelTimeImprovementSuggestionsComponent } from './travel-time-improvement-suggestions/travel-time-improvement-suggestions.component';
import { TravelTimeImprovementSuggestionEditComponent } from './travel-time-improvement-suggestions/edit/travel-time-improvement-suggestion-edit.component';
import { ScrollingModule } from "@angular/cdk/scrolling";
import { RoutePlanningPdfViewComponent } from './tasks/route-planning-pdf-view/route-planning-pdf-view.component';
import {NgOptimizedImage} from "@angular/common";
import {DelayTooltipPipe} from "./pipes/delayTooltip.pipe";

@NgModule({
    declarations: [
        RoutePlanningComponent,
        RoutePlanningInfoComponent,
        RoutePlanningEmployeesComponent,
        RoutePlanningTasksComponent,
        RoutePlanningUnallocatedTasksComponent,
        RoutePlanningExportComponent,
        EmployeeRouteInfoComponent,
        TravelTimeImprovementSuggestionsComponent,
        TravelTimeImprovementSuggestionEditComponent,
        RoutePlanningPdfViewComponent
    ],
    imports: [
        DragDropModule,
        ScrollingModule,
        NgxExtendedPdfViewerModule,
        SharedModule,
        RouteKeyNumbersModule,
        TaskFeasibilityInfoModule,
        RouteKeyNumberModule,
        NgOptimizedImage,
        DelayTooltipPipe
    ]
})
export class RoutePlanningModule {}
